export function HandleNaN(aValue: number): number | null {
  if (isNaN(aValue)) return null;
  else return aValue;
}
